<template>
  <div class="chart">
    <Chart></Chart>
  </div>
</template>

<script>
import Chart from "./Shoppie.js";

export default {
  components: {
    Chart
  }
};
</script>

<style>
</style>